import React, { Component } from "react"
import Recaptcha from "react-google-recaptcha"

import parse from "html-react-parser"
import { navigate } from "gatsby"

const RECAPTCHA_KEY = "6Lc_mi0iAAAAAPxvjkOBguy-Y9VKzHpmRV6HIGSi"

class Form extends Component {
  state = {
    form: {},
  }

  constructor(props) {
    super(props)
    this.form = React.createRef()
  }

  handleChange = (e) => {
    let { form } = this.state
    if (e.target.name === "type") {
      let current = form[e.target.name] || ""
      if (current.indexOf(e.target.value) === -1) {
        // add
        form[e.target.name] = current + " " + e.target.value
      } else {
        // remove
        form[e.target.name] = current.replace(" " + e.target.value, "")
      }
    } else {
      form[e.target.name] = e.target.value
    }
    this.setState({ form })
  }

  handleRecaptcha = (value) => {
    this.setState({ "g-recaptcha-response": value })
  }

  handleSubmit = async (e) => {
    e.preventDefault()

    if (!this.form.current.checkValidity()) return false

    const formData = new FormData(this.form.current)
    formData.append("form-name", this.form.current.getAttribute("name"))
    const queryString = new URLSearchParams(formData).toString()

    // https://zapier.com/editor/204392817/published/204392818/sample
    await fetch(
      "https://hooks.zapier.com/hooks/catch/2181815/39qx8h5/?" + queryString
    )

    this.setState({ result: "success" })
  }

  render() {
    let props = {
      ref: this.form,
      name: "advocacy_register",
      onSubmit: this.handleSubmit,
    }

    if (this.state.result === "success") {
      navigate("/thank-you-advocacy")
      return (
        <div className="signup__nav">
          <p>
            Thanks for getting in contact with us.
            <br /> A member of our team will be in touch soon.
          </p>
        </div>
      )
    }

    return (
      <div className="signup__nav">
        <h4>OBVIOUS:</h4>
        <br />
        <h4>Looking to learn more? </h4>
        <form {...props}>
          <input type="hidden" name="source" value="advocacy_form_block" />
          <p>How can we assist you?</p>
          <ul>
            <li>
              <input
                id={`checkbox_buyer`}
                className="boxes"
                type="checkbox"
                name="checkbox_buyer"
                onChange={this.handleChange}
              />
              <label htmlFor={`checkbox_buyer`}>I’m a Buyer</label>
            </li>
            <li>
              <input
                id={`checkbox_seller`}
                className="boxes"
                type="checkbox"
                name="checkbox_seller"
                onChange={this.handleChange}
              />
              <label htmlFor={`checkbox_seller`}>I’m a Seller</label>
            </li>
            <li>
              <input
                id={`checkbox_request_callback`}
                className="boxes"
                type="checkbox"
                name="checkbox_request_callback"
                onChange={this.handleChange}
              />
              <label htmlFor={`checkbox_request_callback`}>
                Request Callback
              </label>
            </li>
            <li>
              <input
                id={`checkbox_other`}
                className="boxes"
                type="checkbox"
                name="checkbox_other"
                onChange={this.handleChange}
              />
              <label htmlFor={`checkbox_other`}>Other (please specify)</label>
            </li>
          </ul>
          <div className="signup__double">
            <input
              type="text"
              name="fname"
              placeholder="First Name*"
              onChange={this.handleChange}
              required
            />
            <input
              type="text"
              name="lname"
              placeholder="Last Name*"
              onChange={this.handleChange}
              required
            />
          </div>
          <div className="signup__double">
            <input
              type="email"
              name="email"
              placeholder="Email*"
              onChange={this.handleChange}
              required
            />
            <input
              type="text"
              name="phone"
              placeholder="Phone*"
              onChange={this.handleChange}
              required
            />
          </div>
          <textarea
            name="message"
            onChange={this.handleChange}
            placeholder="Leave a message"
          />
          <div className="recaptcha__wrapper">
            <Recaptcha
              ref="recaptcha"
              sitekey={RECAPTCHA_KEY}
              onChange={this.handleRecaptcha}
            />
          </div>
          <button className="contactbtn" type="submit">
            Register now
          </button>
          {this.state.result !== "" && (
            <p
              className="paragraph"
              dangerouslySetInnerHTML={{ __html: this.state.msg }}
            />
          )}
        </form>
      </div>
    )
  }
}

class AdvocacyFormBlock extends Component {
  render() {
    const { title, content, topSuburbs, lastYear } = this.props

    return (
      <section className="advocacy-form" data-color="#FFFFFF" id="register">
        <div className="advocacy-form__inner container">
          {title && <h3 dangerouslySetInnerHTML={{ __html: title }} />}
          <div className="advocacy-form__content">
            <div dangerouslySetInnerHTML={{ __html: content }} />
            <div className="advocacy-form__items">
              <div className="advocacy-form__item">
                <p>Top Suburbs:</p>
                {topSuburbs && (
                  <ul>
                    {topSuburbs.map((item, i) => (
                      <li key={i}>{parse(item.suburb)}</li>
                    ))}
                  </ul>
                )}
              </div>
              <div className="advocacy-form__item">
                <p>In the last year:</p>
                {lastYear && (
                  <ul>
                    {lastYear.map((item, i) => (
                      <li key={i}>{parse(item.text)}</li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
          <div className="advocacy-form__form">
            <Form />
          </div>
        </div>
      </section>
    )
  }
}

export default AdvocacyFormBlock
